import React from 'react';

/** Small filter field for use under a table column header (not full-width toolbar search). */
export default function ColumnFilterInput({
  value,
  onChange,
  placeholder = 'Filter…',
  'aria-label': ariaLabel,
}) {
  return (
    <input
      type="search"
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      aria-label={ariaLabel || placeholder}
      autoComplete="off"
      style={{
        width: '100%',
        boxSizing: 'border-box',
        marginTop: 6,
        padding: '4px 8px',
        border: '1px solid #E5E7EB',
        borderRadius: 6,
        fontSize: 11,
        outline: 'none',
        fontFamily: 'inherit',
        background: '#F9FAFB',
        color: '#374151',
      }}
    />
  );
}
